
const API_URL = process.env.REACT_APP_API_URL;
const APP_KEY = process.env.REACT_APP_KEY;

export const AppConfig = {
    CONFIGURATION: {
        API_URL: API_URL,
        APP_KEY: APP_KEY,
    }
}